export type AppbarItemKey =
	| 'Promotion'
	| 'Home'
	| 'Favorite'
	| 'Sports'
	| 'Statement'
	| 'Me'
	| 'Settings'
	| 'Transaction';

export type AppbarIconName = 'gift' | 'lobby' | 'favorite' | 'sport' | 'my-bet' | 'user' | 'settings' | 'wallet';

export interface AppbarItemConfig {
	key: AppbarItemKey;
	resourceKey: string;
	iconName: AppbarIconName;
	analyseKey?: string;
	href?: string;
	routePrefix?: string;
	routePrefixExclude?: string[];
	kafkaAction?: number;
	/** only for home / promotion page */
	specialKafkaAction?: number;
	tooltipResourceKey?: string;
	actionType?: 'open-profile' | 'toggle-settings';
}

export const APPBAR_ITEM_CONFIG: Record<AppbarItemKey, AppbarItemConfig> = {
	Promotion: {
		key: 'Promotion',
		resourceKey: 'lbl_ECPPromotion',
		iconName: 'gift',
		analyseKey: 'switch-to-promotion-via-app-bar',
		href: '/promotion',
		routePrefix: '/promotion',
		kafkaAction: 20,
		specialKafkaAction: 15,
	},
	Home: {
		key: 'Home',
		resourceKey: 'lbl_home1',
		iconName: 'lobby',
		analyseKey: 'switch-to-lobby-via-app-bar',
		href: '/lobby',
		routePrefix: '/lobby',
		kafkaAction: 1,
		specialKafkaAction: 15,
	},
	Favorite: {
		key: 'Favorite',
		resourceKey: 'lbl_favorite',
		iconName: 'favorite',
		analyseKey: 'switch-to-my-favorites-via-app-bar',
		href: '/favorites',
		routePrefix: '/favorites',
		kafkaAction: 2,
		specialKafkaAction: 14,
	},
	Sports: {
		key: 'Sports',
		resourceKey: 'lbl_SportsParty_Lic',
		iconName: 'sport',
		analyseKey: 'switch-to-odds-page-via-app-bar',
		href: '/sports',
		routePrefix: '/(main)',
		routePrefixExclude: ['/promotion', '/favorites'],
		kafkaAction: 3,
		specialKafkaAction: 13,
	},
	Statement: {
		key: 'Statement',
		resourceKey: 'lbl_Statement',
		iconName: 'my-bet',
		analyseKey: 'switch-to-statement-via-app-bar',
		href: '/bets',
		routePrefix: '/bets',
		kafkaAction: 4,
		specialKafkaAction: 12,
	},
	Me: {
		key: 'Me',
		resourceKey: 'lbl_Meicon',
		iconName: 'user',
		kafkaAction: 21,
		specialKafkaAction: 11,
		tooltipResourceKey: 'lbl_MarsNoticeInfo26',
		actionType: 'open-profile',
	},
	Settings: {
		key: 'Settings',
		resourceKey: 'lbl_CVMenu',
		iconName: 'settings',
		kafkaAction: 5,
		tooltipResourceKey: 'lbl_MarsNoticeInfo27',
		actionType: 'toggle-settings',
	},
	Transaction: {
		key: 'Transaction',
		resourceKey: 'lbl_StatementTransaction',
		iconName: 'wallet',
		analyseKey: 'switch-to-my-transactions-via-app-bar',
		href: '/transaction/deposit',
		routePrefix: '/transaction/deposit',
	},
};